import {equals} from 'ramda';

import {fork, call, put, putResolve, select, all} from 'redux-saga/effects';
import {getCategory, getFilters, setPageNumber} from 'actions/category/category';
import {getCategoryId} from 'selectors/category/category';
import {getActiveFilters, getFilters as getFiltersSelector} from 'selectors/filters/filters';
import {getActiveFiltersFromUrl} from 'libs/category/category';

import dynamicYieldSagaCategory from './sendEventDY/sendEventDY';
import rootFilterSaga, {setActiveFiltersFromUrl} from './filters/filters';
import analyticsCategorySaga from './analytics';
import {onCategoryRouteSave} from 'features/categoryRefinements/sagas/category/category';
import {sessionStore} from 'libs/storage/storage';
import {CATEGORY_STORE} from 'constants/category';

/**
 * Fetching a new category content
 * @param {number} id - Category id
 */
export function* fetchNewCategory(id: number) {
    yield all([putResolve(getFilters(id)), putResolve(getCategory(id))]);
    yield put(setPageNumber(1));
}

/**
 * Checks changes of URL filters after navigation between similar category pages, f.e. contacts brands categories
 */
export function* handleUrlFiltersUpdate() {
    const {items: filterItems} = yield select(getFiltersSelector);
    const filtersFromUrl = yield call(getActiveFiltersFromUrl, filterItems);
    const alreadyAppliedFilters = yield select(getActiveFilters);

    const isFiltersFromUrlAndStoreEquals = equals(filtersFromUrl, alreadyAppliedFilters);
    const categoryPropFromSessionStorage = yield call([sessionStore, 'get'], CATEGORY_STORE);

    if (!isFiltersFromUrlAndStoreEquals) {
        // TODO pass filtersFromUrl to setActiveFiltersFromUrl (GUSA-10003)
        yield call(setActiveFiltersFromUrl);
    } else if (!categoryPropFromSessionStorage) {
        yield call(onCategoryRouteSave);
    }
}

/**
 * Fetching a category content
 * @param {number} id - Category id
 */
export function* fetchCategory(id: number) {
    const oldId = yield select(getCategoryId);

    if (oldId === id) {
        yield call(handleUrlFiltersUpdate);
    } else {
        yield call(fetchNewCategory, id);
        if (__NODEJS__) yield call(setActiveFiltersFromUrl); // since TAKE-effect might be difficult to handle for SSR, the direct calling is added
    }
}

/**
 * Begin of category saga
 */
export default function* categorySaga() {
    yield fork(dynamicYieldSagaCategory);
    yield fork(rootFilterSaga);
    yield fork(analyticsCategorySaga);
}
